namespace TabAurous.OMS {
    export interface UserRoleListRequest extends Serenity.ServiceRequest {
        UserID?: number;
    }
}
